
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/farmbook/videos",
      function () {
        return require("private-next-pages/farmbook/videos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/farmbook/videos"])
      });
    }
  